exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.calendar-icon {\n  font-size: 39px;\n  position: absolute;\n  margin-left: -22px;\n  z-index: 2;\n  color: #848383;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/shared/date-picker-v2/date-picker-v2.component.css
// module id = 944
// module chunks = 3